import React, {useMemo} from "react";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import classNames from "classnames";
import {projectTexts} from "../../constants/copyright";
import styles from "./Project.module.scss";


const ProjectToggle = React.forwardRef(
  function ProjectToggle({season, setSeason, max}, ref) {

    const {button:{text}} = projectTexts.toggle

    const buttons = useMemo(() => {
      return new Array(max).fill(0).map((_, i) => ({
        button: {
          text: `${i + 1} ${text}`,
          className: classNames(buttonStyles.button_toggle, {
            [buttonStyles["button_toggleActive"]]:i===season
          })
        },
        value: i
      }));
    }, [max, season]);

    return (
      <div className={styles.projectToggle} ref={ref}>
        {buttons.map(({button, value}, id) => (
          <Button key={`b-${id}`} {...button} onClick={()=> setSeason(value)}/>
        ))}
      </div>
    );
  });
export default ProjectToggle;
ProjectToggle.propTypes = {};

